import { MicIcon } from "../MicIcon";
import { ArcwarePixelStreaming } from "../../ArcwarePixelStreaming";

export class MicrophoneOverlay {
  private overlay: HTMLElement | null = null;
  private parentElement: HTMLElement | null;
  private micIcon: MicIcon;
  private stream: ArcwarePixelStreaming;

  constructor(stream: ArcwarePixelStreaming) {
    this.stream = stream;
    this.micIcon = new MicIcon();
    this.parentElement = stream?.videoElementParent;
  }

  public createOverlay(): void {
    if (this.parentElement) {
      if (this.overlay) {
        this.parentElement.removeChild(this.overlay);
        this.overlay = null;
      }

      // Create the overlay element
      this.overlay = document.createElement("div");
      this.overlay.id = "microphoneOverlay";
      this.overlay?.classList?.add("hiddenState");

      // Append the icons to the overlay
      this.overlay.appendChild(this.micIcon.micIconUnmuted);
      this.overlay.appendChild(this.micIcon.micIconMuted);
      this.micIcon.micIconMuted.style.display = "none";

      // Create the title div element
      const titleDiv = document.createElement("div");
      titleDiv.className = "title";
      titleDiv.textContent = "Enabling microphone..."; // Default text

      // Create the paragraph element
      const paragraph = document.createElement("p");
      paragraph.textContent =
        "Please check your browser's prompt to allow microphone access. You may also need to re-enable the sound."; // Default text

      // Append the title and paragraph to the overlay
      this.overlay.appendChild(titleDiv);
      this.overlay.appendChild(paragraph);

      // Append the overlay to the parent element
      this.parentElement.appendChild(this.overlay);
    }
  }

  public toggleMessage(enabled: boolean): void {
    if (this.parentElement) {
      if (this.overlay) {
        // Find the title and paragraph elements
        const titleElement = this.overlay.querySelector(".title");
        const paragraphElement = this.overlay.querySelector("p");

        this.micIcon.micIconMuted.style.display = enabled ? "none" : "block";
        this.micIcon.micIconUnmuted.style.display = enabled ? "block" : "none";

        // Update the title and paragraph text
        if (titleElement) titleElement.textContent = enabled ? "Enabling microphone" : "Disabling microphone";
        if (paragraphElement)
          paragraphElement.textContent = enabled
            ? "Please check your browser's prompt to allow microphone access. You may also need to re-enable the sound."
            : "Please wait. You may need to re-enable the sound.";
      }
    }
  }

  public toggleVisibility(visible: boolean): void {
    if (this.parentElement) {
      const infoOverlay = this?.parentElement?.querySelector("#infoOverlay");
      const disconnectOverlay = this?.parentElement?.querySelector("#disconnectOverlay");
      const errorOverlay = this?.parentElement?.querySelector("#errorOverlay");

      const className = "mic-overlay-is-visible";

      if (this.overlay && infoOverlay && disconnectOverlay && errorOverlay) {
        if (visible) {
          infoOverlay?.classList?.add(className);
          disconnectOverlay?.classList?.add(className);
          errorOverlay?.classList?.add(className);
          this?.overlay?.classList?.remove("hiddenState");
        } else {
          this?.overlay?.classList?.add("hiddenState");
          infoOverlay?.classList?.remove(className);
          disconnectOverlay?.classList?.remove(className);
          errorOverlay?.classList?.remove(className);
        }
      }
    }
  }
}
